import React, { useState } from 'react'
import { MoreVertical, Edit, Trash, Eye } from 'lucide-react'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { ACTIONS } from '../../redux/actions'
import { ErrorToast } from '../../Common/Toast'
import { Api } from '../../Service/api'


const PaperBox = ({ paper, onEdit, onDelete, onPreview }) => {

    const dispatch = useDispatch()
    const [showMenu, setShowMenu] = useState(false)

    const toggleMenu = () => setShowMenu(!showMenu)

    const handleAction = async (action) => {
        dispatch(ACTIONS.startLoading())
        try {
            const { data } = await Api.PaperGetById(paper?.id)
            const res = JSON.parse(data)
            if (res?.status === 200) {

                setShowMenu(false)
                switch (action) {
                    case 'edit':
                        onEdit(res?.data)
                        break
                    case 'delete':
                        onDelete(paper?.id)
                        break
                    case 'preview':
                        onPreview(res?.data)
                        break
                }

            }
        } catch (e) {
            ErrorToast(e)
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }

    const backgroundColor = (paper) => {
        switch (paper?.paper_type) {
            case "random":
                return 'bg-yellow-100'
            case "manually":
                return 'bg-blue-100'
            case "auto":
                return 'bg-purple-100'
            default:
                return 'bg-gray-100'
        }
    }

    const buttonBackgroundColor = (paper) => {
        switch (paper?.paper_type) {
            case "random":
                return 'bg-yellow-500'
            case "manually":
                return 'bg-blue-500'
            case "auto":
                return 'bg-purple-500'
            default:
                return 'bg-gray-500'
        }
    }
    const createdDate = moment(paper.createdAt)

    return (
        <div className="bg-white flex rounded-lg shadow-md p-4 relative">
            <div className="absolute top-2 right-2">
                <button onClick={toggleMenu} className="p-1" aria-label="More options">
                    <MoreVertical size={20} />
                </button>
                {showMenu && (
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10">
                        <div className="py-1">
                            <button
                                onClick={() => handleAction('edit')}
                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                            >
                                <Edit size={16} className="inline mr-2" /> Edit Paper
                            </button>
                            <button
                                onClick={() => handleAction('delete')}
                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                            >
                                <Trash size={16} className="inline mr-2" /> Delete
                            </button>
                            <button
                                onClick={() => handleAction('preview')}
                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                            >
                                <Eye size={16} className="inline mr-2" /> Preview
                            </button>
                        </div>
                    </div>
                )}
            </div>
            <div className={`${backgroundColor(paper)} flex flex-col items-center justify-center rounded-lg p-2 inline-block`}>
                <div className="text-sm font-medium text-center">{createdDate.format('DD MMM YYYY')}</div>
                <div className="text-xs">{createdDate.format('hh:mm A')}</div>
                <button className={`${buttonBackgroundColor(paper)} bg-blue-500 text-white text-xs px-2 py-1 rounded mt-1`}>
                    {paper.paper_type.charAt(0).toUpperCase() + paper.paper_type.slice(1)}
                </button>
            </div>
            <div className='ml-4'>
                <div className="font-medium">Paper ID: {paper.id}</div>
                <div>{paper.school_name}</div>
                <div>STD: {paper.standard_name} ({paper.subject_name})</div>
                {paper?.chapter_name && (
                    <div>CH: {paper.chapter_name}</div>
                )}

            </div>
        </div>
    )
}

export default PaperBox